import React from "react"
import { ToggleSwitch } from "../../../components/utils/ToggleSwitch"

export const AttributeOversight = ({ state, setstate, listboxHandler, blurHandler, changeHandler }) => {
    const toogleSwitchHandler = (e: any) => {
        let { input, posting } = state
        if (posting) return

        switch (e.target.name) {
            case 'ownership':
            case 'coowners':
            case 'restricted':
                if (input.format?.key !== 'predefined'
                    && !["radio", "dropdown"].includes(state.input.display_style?.key)
                ) return
                break

            default:
                break;
        }

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                [e.target.name]: e.target.checked
            }
        }))
    }

    return (
        <React.Fragment>
            <div className="w-full mb-2 md:pt-0 pt-1 px-2 flex flex-col md:h-full flex-1">
                <div className="flex-grow">
                    <p className="md:text-xl text-lg text-slate-900 dark:text-white font-medium">
                        Ownership & Oversight
                    </p>

                    <span className="text-red-500 dark:text-red-500 text-xs block pt-2">* Required</span>

                    <div className="w-full pt-3 pb-2 mb-1 border-b border-slate-300 dark:border-slate-600">
                        <ToggleSwitch
                            name={'editable'}
                            label={'Make Attribute User-Editable'}
                            checked={state.input.editable}
                            changeHandler={toogleSwitchHandler}
                            description={"Let users update their own values for this attribute."}
                        />
                    </div>

                    <div className="w-full pt-3 pb-2 mb-1 border-b border-slate-300 dark:border-slate-600">
                        <ToggleSwitch
                            name={'ownership'}
                            label={'Enable Ownership & Oversight'}
                            checked={state.input.ownership}
                            changeHandler={toogleSwitchHandler}
                            description={"Allow this attribute to have designated users (like team leads or managers) e.g. assigning heads to departments or owners to regions."}
                            disabled={state.input.format?.key === 'predefined' && ["radio", "dropdown"].includes(state.input.display_style?.key) ? false : true}
                        />
                    </div>

                    <div className="w-full pt-3 pb-2 mb-1 border-b border-slate-300 dark:border-slate-600">
                        <ToggleSwitch
                            name={'coowners'}
                            label={'Allow Multiple Oversight Users'}
                            checked={state.input.coowners}
                            changeHandler={toogleSwitchHandler}
                            description={"Support more than one assigned user — useful for co-leads or shared ownership scenarios. (e.g., Co-Heads of IT)"}
                            disabled={state.input.ownership && ["radio", "dropdown"].includes(state.input.display_style?.key) ? false : true}
                        />
                    </div>

                    <div className="w-full py-3">
                        <ToggleSwitch
                            name={'restricted'}
                            label={'Restrict Oversight to Roles or Teams'}
                            checked={state.input.restricted}
                            changeHandler={toogleSwitchHandler}
                            description={"Limit selectable overseers to certain roles or teams (e.g. only Admins or HR can be assigned)."}
                            disabled={state.input.ownership && ["radio", "dropdown"].includes(state.input.display_style?.key) ? false : true}
                        />
                    </div>
                </div>

                {
                    state.errors.configuration.length > 0 && (
                        <div className="flex-none">
                            <span className='text-xs py-2 px-2 rounded-md mb-3 flex align-middle items-center bg-red-100 dark:bg-red-900/40 text-red-600 dark:text-red-400 gap-x-2'>
                                <span className="fa-regular fa-exclamation-circle fa-lg"></span>

                                {state.errors.configuration}
                            </span>
                        </div>
                    )
                }
            </div>
        </React.Fragment>
    )
}